<template>
    <EditLiquidation1></EditLiquidation1>
</template>
<script>
    import EditLiquidation1 from '@/components/EditLiquidation1.vue'
    export default {
        name: 'employee-sign',
        components: {
            EditLiquidation1
        }
    }
</script>